import { deriveTracks, statusSentence } from '@/lib/projectPhase';
import type { PhaseInput } from '@/lib/projectPhase';

interface Props {
  input: PhaseInput;
}

function Dot({ filled }: { filled: 'done' | 'busy' | 'none' }) {
  const cls =
    filled === 'done'
      ? 'bg-emerald-500'
      : filled === 'busy'
        ? 'bg-amber-400'
        : 'bg-bmade-300 dark:bg-bmade-700';
  return <span className={`inline-block h-2 w-2 rounded-full ${cls}`} />;
}

/** Statuszin in mensentaal + 3-punts-indicator (akkoord / inkoop / levering). */
export function ProjectPhaseBadge({ input }: Props) {
  const t = deriveTracks(input);
  const akkoord = t.akkoord === 'done' ? 'done' : 'none';
  const inkoop = t.inkoop === 'ordered' ? 'done' : t.inkoop === 'partial' ? 'busy' : 'none';
  const levering = t.levering === 'delivered' ? 'done' : t.levering === 'partial' ? 'busy' : 'none';

  return (
    <div className="flex items-center gap-2">
      <span className="text-bmade-700 dark:text-bmade-300">{statusSentence(input)}</span>
      <span
        className="ml-1 inline-flex items-center gap-1"
        title={`Akkoord: ${t.akkoord} · Inkoop: ${t.inkoop} · Levering: ${t.levering}`}
      >
        <Dot filled={akkoord} />
        <Dot filled={inkoop} />
        <Dot filled={levering} />
      </span>
    </div>
  );
}
